import React from 'react'
import { Link } from 'react-router-dom'

function IndustriesHero() {
    return (
        <section className="about-page-intro industries-hero rts-section-gap">
            <div className="container">
                <div className="row align-items-center g-4 g-xl-5">
                    <div className="col-lg-6 order-2 order-lg-1">
                        <div className="about-page-intro__content">
                            <p className="about-page-intro__label">Industries We Serve</p>
                            <h2 className="about-page-intro__headline">
                                Whatever Your Industry, If You&apos;re Serious About Growth —{' '}
                                <span className="about-page-intro__accent">We Need to Talk</span>
                            </h2>
                            <p className="about-page-intro__disc">
                                Cybersecurity threats don&apos;t pick a sector. Authority content works in every market. And
                                operational excellence has no industry restriction. TechDigit Solutions works where
                                ambition meets complexity.
                            </p>
                            <div className="about-page-intro__cta">
                                <Link to="/contactus" className="rts-btn btn-primary deactive">
                                    Schedule Your Free Consultation
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 order-1 order-lg-2">
                        <div className="about-page-intro__media">
                            <img
                                src="assets/images/about/indus.jpeg"
                                alt=""
                                className="about-page-intro__img"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default IndustriesHero
